import { UiWorkspacePickerModel } from "../../models";

export function mockUiWorkspacePickerModel({
    id = "some-ui-workspace-picker-id",
    locale = "en",
    content = mockUiWorkspacePickerModelContent()
}: Partial<Omit<UiWorkspacePickerModel, "type">> = {}): UiWorkspacePickerModel {
    return {
        id,
        type: "uiWorkspacePicker",
        locale,
        content
    };
}

export type UiWorkspacePickerModelContent = UiWorkspacePickerModel["content"];

export function mockUiWorkspacePickerModelContent({
    entryTitle = "Lorem Ipsum",
    dropdownTitle = "This is a picker",
    noCreditsLeft = "No credits",
    noEligibleAdmin = "No admin",
    noWorkspace = "No Workspace",
    noWorkspaceUrl = "http://www.trello/hello-world",
    invalidLoginToken = "Login",
    urlAppendix = "/some-url"
}: Partial<UiWorkspacePickerModelContent> = {}): UiWorkspacePickerModelContent {
    return {
        entryTitle,
        dropdownTitle,
        noCreditsLeft,
        noEligibleAdmin,
        noWorkspace,
        noWorkspaceUrl,
        invalidLoginToken,
        urlAppendix
    };
}
